import { FC, useEffect, useRef, useState } from "react";
// 组件
import { ProDatePicker } from '../antd';
import SuperSelect from '../SuperSelect';
// 方法
import dayjs from "dayjs";
import classNames from "classnames";
import { renderEnumName } from '../utils/renderUtils';
import { useLayoutContext } from '../PageLayout/context/LayoutContext';
// 常量
import { DateRangeProps, DateRangeValue } from "./interface";
import { TABLE_COLUMN_EMPTY } from '../constants/constant';
import './style.less';

/** 时间区间 */
const DateRange: FC<DateRangeProps> = props => {
  const { value: outValue, defaultValue, disabled, style, classname, datePickerProps, selectProps, onChange, } = props;
  const [value, setValue] = useState<DateRangeValue | undefined>(defaultValue);
  const { enumData } = useLayoutContext();
  const isFirst = useRef<boolean>(true); // 是否需要根据外部传入value设置值
  useEffect(() => {
    if (isFirst.current && !outValue) return;
    setValue(outValue);
    isFirst.current = false;
  }, [outValue]);
  /** 选择时间 */
  const handleDateChange = (date: any, dateString: any) => {
    handleChange({date: dateString});
    datePickerProps?.onChange?.(date, dateString);
  };
  /** 选中时间段 */
  const handleRangeChange = (value: any, options: any) => {
    handleChange({range: value});
    selectProps?.onChange?.(value, options);
  };
  /** value值改变 */
  const handleChange = (data: DateRangeValue) => {
    setValue(prev => {
      const newValue = {...prev, ...data};
      onChange?.(newValue);
      return newValue;
    });
  };
  /** 禁用时展示文字 */
  const renderRange = () => {
    if (value?.range) {
      if (selectProps?.enumCode) {
        return renderEnumName(value.range, enumData?.[selectProps.enumCode].items ?? []);
      }
      if (selectProps?.options) {
        return selectProps.options.find(item => item.value === value.range)?.label;
      }
    }
  };

  return (
    <div className={classNames('yb-date-range', classname, {'yb-date-range-disabled': disabled})} style={style}>
      {
        disabled ? (
          value ? (
            <>
              {!!value?.date && <span>{value?.date}</span>}
              {!!value?.range && <span>{renderRange()}</span>}
            </>
          ) : TABLE_COLUMN_EMPTY
        ) : (
          <>
            <div className="yb-date-range-item yb-date-range-before">
              <ProDatePicker
                {...datePickerProps}
                value={value?.date ? dayjs(value?.date) : undefined}
                onChange={handleDateChange}
                style={{
                  width: '100%',
                  ...datePickerProps?.style,
                }}
              />
            </div>
            <div className="yb-date-range-item yb-date-range-after">
              <SuperSelect
                showSearch={false}
                {...selectProps}
                value={value?.range}
                onChange={handleRangeChange}
                style={{
                  width: '100%',
                  ...selectProps?.style,
                }}
              />
            </div>
          </>
        )
      }
    </div>
  );
};

export default DateRange;
